<button class="btn btn-link tooltip tooltip-{{ tooltipPosition }}" [attr.data-tooltip]="tooltip | translate" [disabled]="isDisabled" (click)="onClick.emit()">
  <material-icon class="remove-icon">highlight_off</material-icon>
</button>
